import http from './index'

const getElectricityCategories = async () => {
    return await http.get('/get/electricity-categories')
}

const proceedElectricity = async (data) => {
    return await http.post('/electricity/initialise', data)
}

const getCableCategories = async () => {
    return await http.get('/get/cable-categories')
}

const verifyCableUser = async (cardNumber, type) => {
    return await http.get(`/get/cable-user/${cardNumber}/${type}`)
}

const getCableProducts = async (cardNumber, type) => {
    return await http.get(`/get/customer-products/${cardNumber}/${type}`)
}

const proceedCable = async (data) => {
    return await http.post('/cable/initialise', data)
}

const getEducationCategories = async () => {
    return await http.get('/get/education-categories')
}

const proceedEducation = async (data) => {
    return await http.post('/education/initialise', data)
}

export {
    getElectricityCategories,
    proceedElectricity,
    getCableCategories,
    verifyCableUser,
    getCableProducts,
    proceedCable,
    getEducationCategories,
    proceedEducation,
}
